export function openTooltip(open, setOpen) {
    if (!open) return setOpen(true);
    return setOpen(false); 
}